import React, { FC, useContext, useEffect } from 'react';
import styles from './CreateGameCategoryForm.module.scss';
import { Input } from 'esa-ui-library';
import { Form } from '../../../components';
import { useStore } from '../../../../common';
import { AuthContext } from '../../../../logic';

interface CreateGameCategoryFormProps {
	isEdit: boolean;
}

const CreateGameCategoryForm: FC<CreateGameCategoryFormProps> = ({ isEdit }): JSX.Element => {
	const [state, dispatch] = useStore();
	const { token } = useContext(AuthContext);
	const { gameCategoryForm, formErrors, success, selectedGameCategory } = state;

	const onChange = (field: string, val: string) => {
		dispatch('FORM', { field, value: val });
	};

	// const onSelect = (field: string, val: PropertyType[]) => {
	// 	dispatch('FORM', { field, value: val });
	// };

	// const onSwitch = (field: string, val: boolean) => {
	// 	dispatch('FORM', { field, value: val });
	// };
	//
	// const addCustomField = () => {
	// 	dispatch('ADD_FIELD');
	// };

	// const removeCustomField = (field: string) => {
	// 	dispatch('REMOVE_FIELD', { field });
	// };

	useEffect(() => {
		if (isEdit && selectedGameCategory) {
			dispatch('GAME_CATEGORY_INIT', { token, id: selectedGameCategory.id });
		}
	}, [isEdit, selectedGameCategory]);

	return (
		<section>
			<Form success={success}>
				<div className={styles.CreateGameCategoryForm}>
					<Input
						className={styles.Input}
						type='text'
						label='Game Category Name'
						value={gameCategoryForm.game_name}
						placeholder='Enter name'
						dataId='game-name-field'
						required
						onChange={(val) => onChange('game_name', val)}
						error={!!formErrors?.game_name}
						errorMessage={formErrors?.game_name}
					/>
				</div>
			</Form>
		</section>
	);
};

export { CreateGameCategoryForm };
